
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-ptruck)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.454 7.636h3.273L24 12v5.455h-2.182a3.275 3.275 0 01-3.273 3.272 3.275 3.275 0 01-3.272-3.272H8.727a3.275 3.275 0 01-3.272 3.272 3.275 3.275 0 01-3.273-3.272H0v-12c0-1.206.976-2.182 2.182-2.182h15.273v4.363zM3.819 17.454c0 .906.731 1.637 1.637 1.637.905 0 1.636-.731 1.636-1.637 0-.905-.731-1.636-1.636-1.636-.906 0-1.637.731-1.637 1.636zm13.091 0c0 .906.731 1.637 1.637 1.637.905 0 1.636-.731 1.636-1.637 0-.905-.731-1.636-1.636-1.636-.906 0-1.637.731-1.637 1.636zm.546-8.181V12h4.87l-2.143-2.727h-2.727zM7.72 14.036c.424.088.86.136 1.308.144v1.056h1.056V14.12c.744-.104 1.304-.344 1.68-.72.376-.384.564-.888.564-1.512 0-.44-.084-.804-.252-1.092-.16-.296-.4-.548-.72-.756-.312-.208-.736-.42-1.272-.636V6.476c.608.032 1.22.188 1.836.468V5.888a5.667 5.667 0 00-1.836-.444V4.376H9.029v1.092c-.696.088-1.252.332-1.668.732-.408.392-.612.884-.612 1.476 0 .584.176 1.068.528 1.452.352.376.924.724 1.716 1.044.008.008.02.012.036.012v2.976a5.637 5.637 0 01-2.352-.54v1.092c.28.136.628.244 1.044.324zm.552-7.056c.176-.192.428-.332.756-.42v2.388c-.36-.184-.62-.368-.78-.552-.152-.192-.228-.432-.228-.72 0-.28.084-.512.252-.696zm2.772 4.908c0 .6-.32.988-.96 1.164V10.64c.344.168.588.344.732.528.152.184.228.424.228.72z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-ptruck"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    